export const mouseLottie = {
    v: '5.9.0',
    fr: 25,
    ip: 0,
    op: 50,
    w: 300,
    h: 860,
    nm: '合成 2',
    ddd: 0,
    assets: [],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 3,
            nm: '空 3',
            sr: 1,
            ks: {
                o: {a: 0, k: 0, ix: 11},
                r: {a: 0, k: 0, ix: 10},
                p: {
                    a: 1,
                    k: [
                        {
                            i: {x: 0.667, y: 1},
                            o: {x: 0.687, y: 0},
                            t: 0,
                            s: [150, 430, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {
                            i: {x: 0.306, y: 1},
                            o: {x: 0.333, y: 0},
                            t: 25,
                            s: [150, 529, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {t: 49, s: [150, 430, 0]},
                    ],
                    ix: 2,
                    l: 2,
                },
                a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
                s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
            },
            ao: 0,
            ip: 0,
            op: 750,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: '形状图层 3',
            parent: 1,
            sr: 1,
            ks: {
                o: {a: 0, k: 100, ix: 11},
                r: {a: 0, k: 0, ix: 10},
                p: {a: 0, k: [0.5, -280.188, 0], ix: 2, l: 2},
                a: {a: 0, k: [0.5, -280.188, 0], ix: 1, l: 2},
                s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
            },
            ao: 0,
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        i: {x: 0.667, y: 1},
                                        o: {x: 0.682, y: 0},
                                        t: 0,
                                        s: [
                                            {
                                                i: [
                                                    [0, 0],
                                                    [0, 0],
                                                ],
                                                o: [
                                                    [0, 0],
                                                    [0, 0],
                                                ],
                                                v: [
                                                    [0.5, -308.75],
                                                    [0.5, -211.625],
                                                ],
                                                c: false,
                                            },
                                        ],
                                    },
                                    {
                                        i: {x: 0.261, y: 1},
                                        o: {x: 0.27, y: 0},
                                        t: 25,
                                        s: [
                                            {
                                                i: [
                                                    [0, 0],
                                                    [0, 0],
                                                ],
                                                o: [
                                                    [0, 0],
                                                    [0, 0],
                                                ],
                                                v: [
                                                    [1, -182.75],
                                                    [1, -125.625],
                                                ],
                                                c: false,
                                            },
                                        ],
                                    },
                                    {
                                        t: 50,
                                        s: [
                                            {
                                                i: [
                                                    [0, 0],
                                                    [0, 0],
                                                ],
                                                o: [
                                                    [0, 0],
                                                    [0, 0],
                                                ],
                                                v: [
                                                    [0.5, -308.75],
                                                    [0.5, -211.625],
                                                ],
                                                c: false,
                                            },
                                        ],
                                    },
                                ],
                                ix: 2,
                            },
                            nm: '路径 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'st',
                            c: {a: 0, k: [1, 1, 1, 1], ix: 3},
                            o: {a: 0, k: 100, ix: 4},
                            w: {a: 0, k: 42, ix: 5},
                            lc: 2,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: '描边 1',
                            mn: 'ADBE Vector Graphic - Stroke',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: {a: 0, k: [0, 0], ix: 2},
                            a: {a: 0, k: [0, 0], ix: 1},
                            s: {a: 0, k: [100, 100], ix: 3},
                            r: {a: 0, k: 0, ix: 6},
                            o: {a: 0, k: 100, ix: 7},
                            sk: {a: 0, k: 0, ix: 4},
                            sa: {a: 0, k: 0, ix: 5},
                            nm: '变换',
                        },
                    ],
                    nm: '形状 1',
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 0,
            op: 750,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: '形状图层 2',
            parent: 1,
            sr: 1,
            ks: {
                o: {a: 0, k: 100, ix: 11},
                r: {a: 0, k: 0, ix: 10},
                p: {a: 0, k: [-1, 247, 0], ix: 2, l: 2},
                a: {a: 0, k: [-1, 247, 0], ix: 1, l: 2},
                s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
            },
            ao: 0,
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    o: [
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    v: [
                                        [-1, 64],
                                        [-1, 430],
                                    ],
                                    c: false,
                                },
                                ix: 2,
                            },
                            nm: '路径 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'st',
                            c: {a: 0, k: [1, 1, 1, 1], ix: 3},
                            o: {a: 0, k: 100, ix: 4},
                            w: {a: 0, k: 12, ix: 5},
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: '描边 1',
                            mn: 'ADBE Vector Graphic - Stroke',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: {a: 0, k: [0, 0], ix: 2},
                            a: {a: 0, k: [0, 0], ix: 1},
                            s: {a: 0, k: [100, 100], ix: 3},
                            r: {a: 0, k: 0, ix: 6},
                            o: {a: 0, k: 100, ix: 7},
                            sk: {a: 0, k: 0, ix: 4},
                            sa: {a: 0, k: 0, ix: 5},
                            nm: '变换',
                        },
                    ],
                    nm: '形状 1',
                    np: 4,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 0,
            op: 750,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 4,
            ty: 4,
            nm: '形状图层 1',
            parent: 1,
            sr: 1,
            ks: {
                o: {a: 0, k: 100, ix: 11},
                r: {a: 0, k: 0, ix: 10},
                p: {a: 0, k: [0, -179, 0], ix: 2, l: 2},
                a: {a: 0, k: [11.637, -174.92, 0], ix: 1, l: 2},
                s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
            },
            ao: 0,
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            ty: 'rc',
                            d: 1,
                            s: {a: 0, k: [287, 487], ix: 2},
                            p: {a: 0, k: [0, 0], ix: 3},
                            r: {a: 0, k: 150, ix: 4},
                            nm: '矩形路径 1',
                            mn: 'ADBE Vector Shape - Rect',
                            hd: false,
                        },
                        {
                            ty: 'st',
                            c: {a: 0, k: [1, 1, 1, 1], ix: 3},
                            o: {a: 0, k: 100, ix: 4},
                            w: {a: 0, k: 12, ix: 5},
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: '描边 1',
                            mn: 'ADBE Vector Graphic - Stroke',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: {a: 0, k: [11.637, -174.92], ix: 2},
                            a: {a: 0, k: [0, 0], ix: 1},
                            s: {a: 0, k: [100, 100], ix: 3},
                            r: {a: 0, k: 0, ix: 6},
                            o: {a: 0, k: 100, ix: 7},
                            sk: {a: 0, k: 0, ix: 4},
                            sa: {a: 0, k: 0, ix: 5},
                            nm: '变换',
                        },
                    ],
                    nm: '矩形 1',
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 0,
            op: 750,
            st: 0,
            bm: 0,
        },
    ],
    markers: [],
};
